import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { SectionWrapper } from './shared/SectionWrapper';
export function Guarantee() {
  return <SectionWrapper bg="cream" noPadding className="py-12" data-id="element-72">
      <div className="max-w-2xl mx-auto text-center px-5" data-id="element-73">
        <div className="flex flex-col items-center justify-center" data-id="element-74">
          <div className="w-16 h-16 rounded-full bg-success/10 flex items-center justify-center mb-4" data-id="element-75">
            <ShieldCheck className="w-8 h-8 text-success" data-id="element-76" />
          </div>
          <h2 className="text-2xl font-serif font-bold text-warm-dark mb-3" data-id="element-77">
            Garantía 7 días
          </h2>
          <p className="text-lg font-bold text-success mb-2" data-id="element-78">
            Probalo sin riesgo.
          </p>
          <p className="text-warm-muted" data-id="element-79">
            Si no es para vos, podés solicitar el reembolso dentro de los{' '}
            <strong data-id="element-80">7 días</strong>.
            <br data-id="element-81" />
            Sin preguntas. Sin vueltas.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}